<template>
  <div class="dropdown" v-click-outside="closeDropdown">
    <button
      @click="toggleDropdown"
      class="dropdown-button form-control"
      type="button"
    >
      <span v-if="selectedItems.length" class="text-capitalize">
        {{ selectedItems.length }}
        <span v-if="selectedItems.length > 1">
          {{selectedDevicesPlaceholder}}
        </span>
        <span v-else>  {{selectedDevicePlaceholder}} </span>
      </span>

      <span v-else> {{selectPlaceholder}} </span>

    </button>
    <div v-if="isOpen" class="dropdown-menu_ w-100">
      <div v-for="(item, index) in items" :key="index" class="dropdown-item">
        <input
          type="checkbox"
          :id="'item-' + index"
          :value="item"
          v-model="selectedItems"
          @change="updateSelectedItems"
        />
        <label
          :for="'item-' + index"
          class="mb-0 text-capitalize cursor-pointer"
          >{{ item.name }}</label
        >
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";

export default {
  name: "Dropdown",
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    itemsSelected: {
      type: Array,
      default: () => [],
    },
    selectPlaceholder: {
      type: String,
      default: () => 'Select Items',
    },
    selectedDevicesPlaceholder: {
      type: String,
      default: () => 'Selected Items',
    },
    selectedDevicePlaceholder: {
      type: String,
      default: () => 'Selected Item',
    }
  },
  data() {
    return {
      isOpen: false,
      selectedItems: [],
    };
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    updateSelectedItems() {
      this.$emit("update:selectedItems", this.selectedItems);
    },
    closeDropdown() {
      this.isOpen = false;
    },
  },
  watch: {
    itemsSelected: {
      immediate: true,
      handler(newVal) {
        this.selectedItems = newVal;
      },
    },
  },
};
</script>

<style scoped>
.dropdown {
  position: relative;
}

.dropdown-button {
  background: rgba(240, 244, 251, 0.6);
  border: none;
  cursor: pointer;
  text-align: start;
}

.dropdown-menu_ {
  display: block;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  max-height: 8rem;
  overflow-y: scroll;
}

.dropdown-item {
  padding: 12px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.dropdown-item:hover {
  background-color: #f1f1f1;
}

.selected-items {
  margin-top: 20px;
}

.selected-items ul {
  list-style-type: none;
  padding: 0;
}

.selected-items li {
  margin: 5px 0;
}
</style>
